import { all, call, delay, put, select, takeLatest } from 'redux-saga/effects'
import { logException } from '~/logging'
import { ACTION, updateProfileAddress, updateProfileFailure, updateProfileSuccess } from './actions'
import { fetchProfile, saveProfile } from './ProfileService'
import { Profile } from './reducers'
import { selectIsLoggedIn } from '../../account/model/selectors'
import { basketSessionStorageName } from '../../basket/model/constants'

function* handleUpdateProfileRequested() {
  const getBasketFromSession = sessionStorage?.getItem(basketSessionStorageName)
  const { isLoggedIn } = yield select(selectIsLoggedIn)
  if (!isLoggedIn) {
    // This is a temporary fix since we implemented the code below, in combination with the restore in the basket saga.
    if (getBasketFromSession) {
      yield delay(100)
    }

    yield put(updateProfileFailure(null))
    return
  }

  try {
    const profile: Profile = yield call(fetchProfile)
    yield put(updateProfileSuccess(profile))
  } catch (error) {
    yield put(updateProfileFailure(error))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* handleUpdateProfile(action: any) {
  if (action.payload.options.isSubmitted) {
    try {
      yield call(saveProfile, action.payload.profile)
      yield put(updateProfileAddress(action.payload.profile.address))
    } catch (error) {
      yield put(updateProfileFailure(error))
      logException(error)
    }
  }
}

export function* profileSaga() {
  yield all([
    takeLatest(ACTION.UPDATE_PROFILE_REQUESTED, handleUpdateProfileRequested),
    takeLatest(ACTION.UPDATE_PROFILE, handleUpdateProfile),
  ])
}
